import { render } from "./ScreenShot.vue?vue&type=template&id=22bf12d4&scoped=true"
import script from "./ScreenShot.vue?vue&type=script&lang=js"
export * from "./ScreenShot.vue?vue&type=script&lang=js"

import "./ScreenShot.vue?vue&type=style&index=0&id=22bf12d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bf12d4"]])

export default __exports__